import React from 'react';
import ReactDOM from 'react-dom/client';
import Alert from './component/Alert/Alert';
import App from './container/App';
import { BrowserRouter } from 'react-router-dom';
import AlertProvider from './component/Alert/AlertProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AlertProvider>
      <BrowserRouter>
        <App />
        <Alert />
      </BrowserRouter>
    </AlertProvider>
  </React.StrictMode>
);
